/**
 * Model to handle session
 */
define('dataSource/session',['jquery', 'atn/atn', 'knockout', 'lodash'],
    function($, atn, ko, _) {
        'use strict';
        /**
         * session
         * @type {ko.observableArray}
         */
        var session = ko.observable({});
        /**
         * observable object for handling errors in loading of session
         * @type {ko.observable}
         */
        var errorLoadingSession = ko.observable({});

        //the below code clears the observables passed on logout.
        atn.dataCache.addRegistry([session, errorLoadingSession]);

        return {
            session: session,
            errorLoadingSession: errorLoadingSession,
            getSession: getSession,
            setSession:setSession
        };
        /**
         * function to get session
         * @param  {boolean} reload        is reload required?
         * @return {jquery.promise}        promise for getting session
         */
        function getSession(reload) {
            return (reload || _.isEmpty(session())) ? fetchSession() : atn.utils.dummySuccessDeferred(session());
        }

        /**
         * [setSession function to set session]
         * @param {string} ticket [the cas session ticket]
         */
        function setSession(ticket){

            var ajaxSettings = {
                url: atn.config.api.sessionData + '?ticket='+ ticket,
                type: 'POST',
                dataType: 'json',
                data: null
            };

            var promise = $.ajax(ajaxSettings);

            return promise;
        }

        /**
         * [setSession function to set session]
         * @param {string} ticket [the cas session ticket]
         */
        function setSession(ticket){

            var ajaxSettings = {
                url: atn.config.api.sessionData + '?ticket='+ ticket,
                type: 'POST',
                dataType: 'json',
                data: null
            };

            var promise = $.ajax(ajaxSettings);

            return promise;
        }

        /**
         * fetches the session into session
         * @return {promise} promise object for fetching session
         */
        function fetchSession() {
            session({});
            return atn.rest.getObject(
                atn.config.api.sessionData,
                'session_data',
                session,
                errorLoadingSession
            );
        }
    });
